import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    this.drawer = document.getElementById("settings_drawer")

    // Inicializar estado del toggle de modo oscuro
    const darkModeToggle = document.getElementById('dark-mode-toggle')
    if (darkModeToggle) {
      darkModeToggle.checked = document.documentElement.classList.contains('dark')

      // Manejar cambio de modo oscuro
      darkModeToggle.addEventListener('change', (e) => {
        fetch('/users/toggle_dark_mode', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
          }
        }).then(() => {
          if (e.target.checked) {
            document.documentElement.classList.add('dark')
            document.body.classList.add('dark')
          } else {
            document.documentElement.classList.remove('dark')
            document.body.classList.remove('dark')
          }
        })
      })
    }

    // Escuchar eventos del drawer
    document.addEventListener("drawer:show", () => this.showDrawer())
    document.addEventListener("drawer:hide", () => this.hideDrawer())

    // Manejar cambio de idioma
    const localeSelect = this.element.querySelector('select')
    if (localeSelect) {
      localeSelect.addEventListener('change', (e) => {
        const locale = e.target.value
        fetch('/users/update_locale', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({ locale })
        }).then(() => {
          window.location.reload()
        })
      })
    }
  }

  showDrawer() {
    this.drawer.classList.remove("translate-x-full")
    this.drawer.removeAttribute("aria-hidden")
    this.drawer.removeAttribute("inert")
    this.showOverlay()
  }

  hideDrawer() {
    this.drawer.classList.add("translate-x-full")
    this.drawer.setAttribute("aria-hidden", "true")
    this.drawer.setAttribute("inert", "")
    this.hideOverlay()
  }

  showOverlay() {
    this.overlayTarget.classList.remove("hidden")
  }

  hideOverlay() {
    this.overlayTarget.classList.add("hidden")
  }
}
